import React from 'react';
import { ROOT_URL, FLAG_VALUE } from './app-constants';

const _padZero = (val) => {
  if (val < 10) {
    return `0${val}`;
  }

  return val;
};

export const padZero = (val) => {
  if (val < 10) {
    return `0${val}`;
  }

  return val;
};

export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const validateUserName = (userName) => {
  return userName.length >= 2 &&
    userName.length <= 20 &&
    userName.indexOf(' ') === -1;
};

export const addBaseURL = (options) => {
  if (process.env.NODE_ENV === 'development') {
    options.baseURL = ROOT_URL;
  }
};

const _toTitleCase = (str) => {
  return `${str.charAt(0).toUpperCase()}${str.substring(1).toLowerCase()}`;
};

export const titleCase = (str) => {
  if (!str || !str.length) {
    return '';
  }

  if (str.length === 0) {
    return str;
  }
  if (str.indexOf(' ') < 0) {
    return _toTitleCase(str);
  }

  return str
    .split(' ')
    .map((word) => {
      if (word) {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      } else {
        return '';
      }
    })
    .join(' ');
};

export const generateDisplayName = (org) => {
  // Entities abbreviation to omit from name
  const entities = [
    'LP',
    'LLP',
    'LLLP',
    'LLC',
    'PC',
    'PLLC',
    'PLC',
    'CORP',
    'PBC',
    'INC',
    'LTD'
  ];
  // Omit comma and periods
  let displayName = org.replace('.', '').replace(',', '').toUpperCase();
  // Omit entities as described above and trim
  for (let i = 0; i < entities.length; i++) {
    if (displayName.indexOf(entities[i]) > 0) {
      displayName = displayName.replace(entities[i], '');
    }
  }
  displayName = displayName.trim();

  let result = '';
  const tmp = displayName.split(' ');

  if (tmp.length <= 1) {
    return `${org.charAt(0)}${org.substring(1).toLowerCase()}`;
  }

  for (let i = 0; i < tmp.length; i++) {
    result = result + _toTitleCase(tmp[i]) + ' ';
  }

  return result.trim().substring(0, 40);
};

export const getDateString = (val, showTimezoneOffset = true) => {
  let currentDate = new Date();
  if (val) {
    currentDate = new Date(val);
  }

  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];

  const month = months[currentDate.getMonth()];
  const date = currentDate.getDate();
  const year = currentDate.getFullYear();
  const hours = _padZero(currentDate.getHours());
  const minutes = _padZero(currentDate.getMinutes());
  // const seconds = _padZero(currentDate.getSeconds());

  if (showTimezoneOffset) {
    const tzOffset = currentDate.getTimezoneOffset() > 0
      ? `UTC-${currentDate.getTimezoneOffset() / 60}`
      : `UTC+${currentDate.getTimezoneOffset() / 60}`;

    // May25, 2020 23:23:34 (UTC+13)
    // return `${month}${date}, ${year} ${hours}:${minutes}:${seconds} (${tzOffset})`;

    // May25, 2020 @ 23:23 UTC+13
    return `${month}${date}, ${year} @ ${hours}:${minutes} ${tzOffset}`;
  }
  return `${month} ${date}, ${year}`;
};

export const getTimeString = (val) => {
  let currentDate = new Date();
  if (val) {
    currentDate = new Date(val);
  }
  const hours = _padZero(currentDate.getHours());
  const minutes = _padZero(currentDate.getMinutes());
  // const seconds = _padZero(currentDate.getSeconds());

  const tzOffset = currentDate.getTimezoneOffset() > 0
    ? `UTC-${currentDate.getTimezoneOffset() / 60}`
    : `UTC+${currentDate.getTimezoneOffset() / 60}`;

  // May25, 2020 23:23:34 (UTC+13)
  // return `${month}${date}, ${year} ${hours}:${minutes}:${seconds} (${tzOffset})`;

  // May25, 2020 @ 23:23 UTC+13
  return `${hours}:${minutes} ${tzOffset}`;
};

export const debugLogToConsole = (function () {
  if (process.env.NODE_ENV === 'development') {
    return console.log;
  } else {
    return () => { };
  }
})();

export const getWeekDay = (num) => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[num];
};

export const getShortWeekDay = (num) => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return days[num];
};

export const getMonthName = (num) => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  return months[num];
};

export const parseName = (value) => {
  if (value.length < 1) {
    return ['', ''];
  }

  const isLastNameFirst = value.includes(',');
  const name = value.replace(',', '').replace('  ', ' ');
  const nameArr = name.split(' ');
  let firstName = '';
  let lastName = '';

  if (isLastNameFirst) {
    firstName = nameArr[1];
    lastName = nameArr[0];
  } else {
    firstName = nameArr[0];
    lastName = nameArr[1];
  }

  return [firstName, lastName];
};

export const formatPhoneNumber = (pNumber = '') => {
  return `${pNumber.slice(0, 3)}-${pNumber.slice(3, 6)}-${pNumber.slice(6)}`;
};

const escapeRegExp = text => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

export const getHighlightedText = (text = '', highlight = '') => {
  const hightlightParts = highlight.split(' ');
  let regexString = '';

  // Build regex for highlighted text
  for (let i = 0; i < hightlightParts.length; i++) {
    const tmpRegex = escapeRegExp(hightlightParts[i]); // Partial word search
    regexString = regexString + `(${tmpRegex})${i < hightlightParts.length - 1 ? '|' : ''}`;
  }

  if (!text) {
    return <span />;
  }

  const parts = text.split(new RegExp(regexString, 'gi'));
  return (
    <span className='sentence-case'>
      {parts.map((part, idx) => {
        if (!part) { return null; }
        if (hightlightParts.findIndex(item => part.toLowerCase() === item.toLowerCase()) > -1) {
          return (
            <mark
              key={`search_${idx}`}
            // style={{ color: 'white', background: blue[600] }}
            >
              {part}
            </mark>
          );
        }
        return part;
      }
      )}
    </span>
  );
};

/* eslint-disable */
export const dataURItoBlob = (dataURI) => {
  if (typeof dataURI !== 'string') {
    throw new Error('Invalid argument: dataURI must be a string');
  }
  dataURI = dataURI.split(',');
  var type = dataURI[0].split(':')[1].split(';')[0],
    byteString = atob(dataURI[1]),
    byteStringLength = byteString.length,
    arrayBuffer = new ArrayBuffer(byteStringLength),
    intArray = new Uint8Array(arrayBuffer);
  for (var i = 0; i < byteStringLength; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], {
    type: type
  });
}

export const fileToBlob = async (file) => new Blob([new Uint8Array(await file.arrayBuffer())], { type: file.type });

// dateString format -> "mm/dd/yyyy"
export const calculateAge = (dateString) => {
  var now = new Date();
  var today = new Date(now.getYear(), now.getMonth(), now.getDate());

  var yearNow = now.getYear();
  var monthNow = now.getMonth();
  var dateNow = now.getDate();

  var dob = new Date(dateString.substring(6, 10),
    dateString.substring(0, 2) - 1,
    dateString.substring(3, 5)
  );

  var yearDob = dob.getYear();
  var monthDob = dob.getMonth();
  var dateDob = dob.getDate();
  var age = {};
  var ageString = "";
  var yearString = "";
  var monthString = "";
  var dayString = "";


  var yearAge = yearNow - yearDob;

  if (monthNow >= monthDob)
    var monthAge = monthNow - monthDob;
  else {
    yearAge--;
    var monthAge = 12 + monthNow - monthDob;
  }

  if (dateNow >= dateDob)
    var dateAge = dateNow - dateDob;
  else {
    monthAge--;
    var dateAge = 31 + dateNow - dateDob;

    if (monthAge < 0) {
      monthAge = 11;
      yearAge--;
    }
  }

  age = {
    years: yearAge,
    months: monthAge,
    days: dateAge
  };

  if (age.years > 1) yearString = " years";
  else yearString = " year";
  if (age.months > 1) monthString = " months";
  else monthString = " month";
  if (age.days > 1) dayString = " days";
  else dayString = " day";


  // if ( (age.years > 0) && (age.months > 0) && (age.days > 0) )
  //   ageString = age.years + yearString + ", " + age.months + monthString + ", and " + age.days + dayString + " old.";
  // else if ( (age.years == 0) && (age.months == 0) && (age.days > 0) )
  //   ageString = "Only " + age.days + dayString;
  // else if ( (age.years > 0) && (age.months == 0) && (age.days == 0) )
  //   ageString = age.years + yearString;
  // else if ( (age.years > 0) && (age.months > 0) && (age.days == 0) )
  //   ageString = age.years + yearString + " and " + age.months + monthString;
  // else if ( (age.years == 0) && (age.months > 0) && (age.days > 0) )
  //   ageString = age.months + monthString + " and " + age.days + dayString;
  // else if ( (age.years > 0) && (age.months == 0) && (age.days > 0) )
  //   ageString = age.years + yearString + " and " + age.days + dayString;
  // else if ( (age.years == 0) && (age.months > 0) && (age.days == 0) )
  //   ageString = age.months + monthString;
  // else ageString = "Oops! Could not calculate age!";

  // return ageString;

  if (age.years === 0 && age.months === 0 && age.days > 0) {
    ageString = `${age.days}d`
  } else if (age.years < 3 && age.months <= 11) {
    ageString = `${(age.years * 12) + age.months}m${age.days > 0 ? `${age.days}d` : ''}`;
  } else if (age.years >= 3 && age.years <= 13) {
    ageString = `${age.years}y${age.months > 0 ? `${age.months}m` : ''}`;
  } else if (age.years > 13) {
    ageString = `${age.years}y`;
  } else if (age.years === 0 && age.months === 0 && age.days === 0) {
    ageString = 'N/A';
  }

  return ageString;
}

export const findFlag = (...flags) => {
  let result = null;
  let noneCounter = 0;
  for (let i = 0; i < flags.length; i++) {
    // console.log(`${i} - ${flags[i]}`);
    if (flags[i] === FLAG_VALUE.critical) {
      return FLAG_VALUE.critical;
    }

    if (flags[i] === FLAG_VALUE.warning) {
      result = FLAG_VALUE.warning;
    }

    if (flags[i] === FLAG_VALUE.success) {
      if (!result) {
        result = FLAG_VALUE.success;
      }
    }

    if (flags[i] === FLAG_VALUE.none) {
      noneCounter += 1;
    }
  }
  if (noneCounter === flags.length) {
    return FLAG_VALUE.none
  } else {
    return result;
  }
};

export const calculateTimeDiff = (startTime, endTime) => {
  const start = startTime.split(":");
  const end = endTime.split(":");
  const startDate = new Date(0, 0, 0, start[0], start[1], 0);
  const endDate = new Date(0, 0, 0, end[0], end[1], 0);
  let diff = endDate.getTime() - startDate.getTime();
  let hours = Math.floor(diff / 1000 / 60 / 60);
  diff -= hours * 1000 * 60 * 60;
  const minutes = Math.floor(diff / 1000 / 60);

  // If using time pickers with 24 hours format, add the below line get exact hours
  if (hours < 0)
    hours = hours + 24;

  // return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  return hours * 60 + minutes;
};

export const ascendingSortCaseSchedulesByStart = (a, b) => {
  const aDos = a.scheduleStartDate.split("T")[0].split("-");
  const aTime = new Date(
    +aDos[0],
    +aDos[1],
    +aDos[2],
    a.scheduleStartHour,
    a.scheduleStartMinute,
  ).getTime();

  const bDos = b.scheduleStartDate.split("T")[0].split("-");
  const bTime = new Date(
    +bDos[0],
    +bDos[1],
    +bDos[2],
    b.scheduleStartHour,
    b.scheduleStartMinute,
  ).getTime();

  return aTime - bTime;
};

export const ascendingSortProviderBlocksByStart = (a, b) => {
  const cDate = new Date();
  const aTime = new Date(
    cDate.getFullYear(),
    cDate.getMonth(),
    cDate.getDate(),
    a.startHour,
    a.startMinute
  ).getTime();

  const bTime = new Date(
    cDate.getFullYear(),
    cDate.getMonth(),
    cDate.getDate(),
    b.endHour,
    b.endMinute,
  ).getTime();

  return aTime - bTime;
};

export const parseDateFromIsoString = (dateString = new Date().toISOString()) => {
  const dateStringParts = dateString.split('T');
  if (!Array.isArray(dateStringParts) || dateStringParts.length === 0) {
    throw new Error('Invalid date string parameter');
  }

  const dateParts = dateStringParts[0].split('-');
  if (!Array.isArray(dateParts) || dateParts.length < 3) {
    throw new Error('Invalid date string parameter');
  }

  return {
    year: +dateParts[0],
    month: +dateParts[1] - 1,
    date: +dateParts[2]
  };
}

export const parseDateStringFromIsoDate = (dateString = new Date().toISOString()) => {
  const dateStringParts = dateString.split('T');
  if (!Array.isArray(dateStringParts) || dateStringParts.length === 0) {
    throw new Error('Invalid date string parameter');
  }

  const dateParts = dateStringParts[0].split('-');
  if (!Array.isArray(dateParts) || dateParts.length < 3) {
    throw new Error('Invalid date string parameter');
  }

  return `${padZero(+dateParts[1])}/${padZero(+dateParts[2])}/${+dateParts[0]}`;
}

export const makeIsoDateString = (year, month, date) => {
  if (!Number.isInteger(+year) || !Number.isInteger(+month) || !Number.isInteger(date)) {
    throw new Error('Function args year, month, or date are not integers and also cannot be parsed to integers');
  }
  return `${year}-${padZero(+month + 1)}-${padZero(+date)}T00:00:00.000+0000`;
};

export const calculateCaseBlockTimeInMinutes = (startDate, startHour, startMinute, endDate, endHour, endMinute) => {
  if (isNaN(Date.parse(startDate)) ||
    isNaN(parseInt(startHour)) ||
    isNaN(parseInt(startMinute)) ||
    isNaN(Date.parse(endDate)) ||
    isNaN(parseInt(endHour)) ||
    isNaN(parseInt(endMinute)) ||
    (startHour === 0 && startMinute === 0) ||
    (endHour === 0 && endMinute === 0)
  ) {
    return '? mins';
  }
  const sDate = new Date(Date.parse(startDate));
  const sTime = new Date(sDate.getFullYear(), sDate.getMonth(), sDate.getDate(), startHour, startMinute).getTime();

  const eDate = new Date(Date.parse(endDate));
  const eTime = new Date(eDate.getFullYear(), eDate.getMonth(), eDate.getDate(), endHour, endMinute).getTime();

  return `${(Math.round(eTime - sTime) / 1000 / 60)} mins`;
}
/* eslint-enable */

export const getPathParts = (path) => {
  if (path.length === 0 || path.indexOf('/') < 0) {
    return [];
  }
  return path.startsWith('/') ? path.substr(1).split('/') : path.substr(0).split('/');
};

/**
 * Converts a base64 encoded image string to a Blob object.
 *
 * @param {string} base64Image - The base64 encoded image string.
 * @returns {Blob} The Blob object representing the image.
 */
export const base64ToBlob = (base64Image) => {
  // Split the base64 string into data and contentType
  const parts = base64Image.split(",");
  const contentType = parts[0].split(":")[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
};

/* eslint-disable */
export const equal = (a, b) => {
  if (a === b) return true;

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (a.constructor !== b.constructor) return false;

    let length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (a instanceof Map && b instanceof Map) {
      if (a.size !== b.size) return false;
      for (let [key, value] of a.entries())
        if (!b.has(key)) return false;
      for (let [key, value] of a.entries())
        if (!equal(value, b.get(key))) return false;
      return true;
    }

    if (a instanceof Set && b instanceof Set) {
      if (a.size !== b.size) return false;
      for (let item of a.values())
        if (!b.has(item)) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      const key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a !== a && b !== b;
};

export const findBase64ImageMimeType = (base64Str) => {
  // Regular expression to match the MIME type at the beginning of a Base64 string
  const regex = /^data:(\w+\/[\w+\-\.]+);base64,/;
  const match = base64Str.match(regex);

  // If there's a match, return the MIME type
  if (match && match.length > 1) {
    return match[1];
  }

  // If no MIME type is found, return undefined or a default value
  return undefined;
};

export const findFileExtensionByMimeType = (mimeType) => {
  const mimeToExtension = {
    'text/plain': '.txt',
    'text/html': '.html',
    'text/css': '.css',
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'application/javascript': '.js',
    'application/json': '.json',
    'application/pdf': '.pdf',
    // Add more MIME types and their corresponding extensions as needed
  };

  return mimeToExtension[mimeType] || 'Unknown extension';
};

export const findPageById = (pages, currentId) => {
  return pages.findIndex(page => page.id === currentId);
};

export const base64ToFile = (base64String, filename) => {
  // Extract the MIME type and base64 data
  const [, mimeType, base64Data] = base64String.match(/^data:(.*);base64,(.*)$/);

  // Decode the base64 string
  const binaryString = atob(base64Data);

  // Create an array buffer from the binary string
  const bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  // Create a Blob from the array buffer
  const blob = new Blob([bytes], { type: mimeType });

  // Create a File object from the Blob
  return new File([blob], filename, { type: mimeType });
}

export const calculateCaseScheduleTimesFlag = (
  anesStartDate,
  anesEndDate,
  surgStartDate,
  surgEndDate,
  asHour,
  asMinute,
  aeHour,
  aeMinute,
  ssHour,
  ssMinute,
  seHour,
  seMinute
) => {
  const anesStart = new Date(anesStartDate);
  const asDate = anesStart.getDate();
  const asMonth = anesStart.getMonth();
  const asYear = anesStart.getFullYear();
  const isAnesStartTimePristine = asHour === undefined || asMinute === undefined;

  const anesEnd = new Date(anesEndDate);
  const aeDate = anesEnd.getDate();
  const aeMonth = anesEnd.getMonth();
  const aeYear = anesEnd.getFullYear();

  const surgStart = new Date(surgStartDate);
  const ssDate = surgStart.getDate();
  const ssMonth = surgStart.getMonth();
  const ssYear = surgStart.getFullYear();

  const surgEnd = new Date(surgEndDate);
  const seDate = surgEnd.getDate();
  const seMonth = surgEnd.getMonth();
  const seYear = surgEnd.getFullYear();

  const anesStartDateTimeInseconds = new Date(asYear, asMonth, asDate, asHour, asMinute).getTime();
  const anesEndDateTimeInseconds = new Date(aeYear, aeMonth, aeDate, aeHour, aeMinute).getTime();
  const surgStartDateTimeInSeconds = new Date(ssYear, ssMonth, ssDate, ssHour, ssMinute).getTime();
  const surgEndDateTimeInSeconds = new Date(seYear, seMonth, seDate, seHour, seMinute).getTime();
  const anesStartFlag = isAnesStartTimePristine ? FLAG_VALUE.critical : FLAG_VALUE.success;
  const surgStartFlag = surgStartDateTimeInSeconds - anesStartDateTimeInseconds > 0 ? FLAG_VALUE.success : FLAG_VALUE.critical;
  const surgEndFlag = surgEndDateTimeInSeconds - surgStartDateTimeInSeconds > 0 ? FLAG_VALUE.success : FLAG_VALUE.critical;
  const anesEndFlag = anesEndDateTimeInseconds - surgEndDateTimeInSeconds > 0 ? FLAG_VALUE.success : FLAG_VALUE.critical;
  const timeFlag = findFlag(anesStartFlag, surgStartFlag, surgEndFlag, anesEndFlag);
  return timeFlag;
};

// Case schedule dashboard - case data flag
// NOTE: does not include patient and payer data
export const calculateCaseScheduleDataFlag = (caseData) => {
  const {
    scheduleStartDate,
    scheduleStartHour: startHour,
    scheduleStartMinute: startMinute,
    scheduleEndDate,
    scheduleEndHour: endHour,
    scheduleEndMinute: endMinute,
    patientType,
    facility = {},
    selectedFacilityLocation: sfl = 'TBD (To Be Determined)',
    surgeons = [], 
    surgicalProcedures = [],
    otherSurgicalProcedures = [],
    isSkipPreOpDx = false,
    preOpDx = [],
    otherPreOpDx = [],
    postOpDx = [],
    otherPostOpDx = [],
    isSameAsPreOpDx = false,
    anesthesiologists = [],
    isNoneAnesthesiologist = false,
    crna = [],
    isNoneCrna = false,
    lien = 'No',
    workmanComp = 'No',
    unknownEnd = 'No',
    // --- Case times
    anesthesiaStartDate,
    anesthesiaEndDate,
    surgeryStartDate,
    surgeryEndDate,
    anesthesiaEndHour: aeHour,
    anesthesiaEndMinute: aeMinute,
    anesthesiaStartHour: asHour,
    anesthesiaStartMinute: asMinute,
    surgeryEndHour: seHour,
    surgeryEndMinute: seMinute,
    surgeryStartHour: ssHour,
    surgeryStartMinute: ssMinute,
  } = caseData;

  // --- Case schedule start/end times flag
  // --------------------------------------------------------------------------
  const startDate = new Date(scheduleStartDate).getDate();
  const startMonth = new Date(scheduleStartDate).getMonth();
  const startYear = new Date(scheduleStartDate).getFullYear();
  const scheduleStartTimeInSeconds = new Date(startYear, startMonth, startDate, startHour, startMinute);

  const endDate = new Date(scheduleEndDate).getDate();
  const endMonth = new Date(scheduleEndDate).getMonth();
  const endYear = new Date(scheduleEndDate).getFullYear();
  const scheduleEndTimeInSeconds = new Date(endYear, endMonth, endDate, endHour, endMinute);

  const scheduleStartEndTimesFlag = scheduleEndTimeInSeconds > scheduleStartTimeInSeconds
    ? FLAG_VALUE.success
    : FLAG_VALUE.critical;

  // --- Admission type flag
  // --------------------------------------------------------------------------
  const admissionTypes = ['InPatient', 'OutPatient', 'InPt', 'OutPt'];
  const admissionTypeFlag = admissionTypes.findIndex(el => el === patientType) > -1
    ? FLAG_VALUE.success
    : FLAG_VALUE.critical

  // --- Facility flag
  // --------------------------------------------------------------------------
  // TBD (To Be Determined)
  const facFlag = Object.keys(facility).length > 0
    ? FLAG_VALUE.success
    : FLAG_VALUE.critical;
  const facLocFlag = sfl.length > 0 && sfl !== 'TBD (To Be Determined)'
    ? FLAG_VALUE.success
    : FLAG_VALUE.critical;
  const facilityFlag = findFlag(facFlag, facLocFlag);

  // --- Surgeons
  const surgeonsFlag = Array.isArray(surgeons) && surgeons.length > 0
    ? FLAG_VALUE.success
    : FLAG_VALUE.critical;

  // Surgical procedures
  let surgicalProceduresFlag = FLAG_VALUE.critical;
  if (Array.isArray(surgicalProcedures) && Array.isArray(otherSurgicalProcedures)) {
    if (surgicalProcedures.length === 0 && otherSurgicalProcedures.length === 0) {
      surgicalProceduresFlag = FLAG_VALUE.critical;
    } else {
      if (surgicalProcedures.length > 0) {
        surgicalProceduresFlag = FLAG_VALUE.success;
      } else {
        if (otherSurgicalProcedures.length > 0) {
          surgicalProceduresFlag = FLAG_VALUE.warning;
        }
      }
    }
  }

  // const surgicalProceduresFlag = Array.isArray(surgicalProcedures) && surgicalProcedures.length > 0
  //   ? FLAG_VALUE.success
  //   : FLAG_VALUE.critical

  // --- PreOpDx flag
  let preOpDxFlag = FLAG_VALUE.critical;
  if (Array.isArray(preOpDx) && Array.isArray(otherPreOpDx)) {
    if (preOpDx.length === 0 && otherPreOpDx.length === 0) {
      preOpDxFlag = FLAG_VALUE.critical;
    } else {
      if (preOpDx.length > 0) {
        preOpDxFlag = FLAG_VALUE.success;
      } else {
        if (otherPreOpDx.length > 0) {
          preOpDxFlag = FLAG_VALUE.warning;
        }
      }
    }
  }
  // const preOpDxFlag = Array.isArray(preOpDx) && preOpDx.length > 0
  //   ? FLAG_VALUE.success
  //   : FLAG_VALUE.critical;

  // PostOpDx Flag
  let postOpDxFlag = FLAG_VALUE.critical;
  if (isSameAsPreOpDx) {
    postOpDxFlag = preOpDxFlag;
  } else {
    if (Array.isArray(postOpDx) && Array.isArray(otherPostOpDx)) {
      if (postOpDx.length === 0 && otherPostOpDx.length === 0) {
        postOpDxFlag = FLAG_VALUE.critical;
      } else {
        if (postOpDx.length > 0) {
          postOpDxFlag = FLAG_VALUE.success;
        } else {
          if (otherPostOpDx.length > 0) {
            postOpDxFlag = FLAG_VALUE.warning;
          }
        }
      }
    }
    // postOpDxFlag = Array.isArray(postOpDx) && postOpDx.length > 0
    //   ? FLAG_VALUE.success
    //   : FLAG_VALUE.critical;
  }

  // --- Anesthesiologists flag
  let anesthesiologistsFlag = FLAG_VALUE.critical;
  if (isNoneAnesthesiologist) {
    anesthesiologistsFlag = FLAG_VALUE.none;
  } else {
    anesthesiologistsFlag = Array.isArray(anesthesiologists) && anesthesiologists.length > 0
      ? FLAG_VALUE.success
      : FLAG_VALUE.critical;
  }

  // --- CRNA flag
  let crnasFlag = FLAG_VALUE.critical;
  if (isNoneCrna) {
    crnasFlag = FLAG_VALUE.none;
  } else {
    crnasFlag = Array.isArray(crna) && crna.length > 0
      ? FLAG_VALUE.success
      : FLAG_VALUE.critical;
  }

  // --- Case times flags
  const caseTimesFlag = calculateCaseScheduleTimesFlag(
    anesthesiaStartDate,
    anesthesiaEndDate,
    surgeryStartDate,
    surgeryEndDate,
    asHour,
    asMinute,
    aeHour,
    aeMinute,
    ssHour,
    ssMinute,
    seHour,
    seMinute
  );

  // -- Lien, Workman comp and unknown end flag
  // const lwuFlag = lien.length > 0 && workmanComp.length > 0 && unknownEnd.length > 0
  //   ? FLAG_VALUE.success
  //   : FLAG_VALUE.critical;
  const lwuFlag = FLAG_VALUE.success;
  
  // --- Case Data flag calculation
  const caseDataFlag = findFlag(
    scheduleStartEndTimesFlag,
    admissionTypeFlag,
    facilityFlag,
    surgeonsFlag,
    surgicalProceduresFlag,
    preOpDxFlag,
    postOpDxFlag,
    anesthesiologistsFlag,
    crnasFlag,
    caseTimesFlag,
    lwuFlag
  );

  return caseDataFlag;
};

export const isValidUSPhoneNumber = (phoneNumber) => {
  // Define the regex pattern for USA phone numbers
  const phonePattern = /^(1\s?)?(\(\d{3}\)|\d{3})[\s\-]?\d{3}[\s\-]?\d{4}$/;

  // Test the input phone number against the regex pattern
  return phonePattern.test(phoneNumber);
};

export const checkWebPSupport = () => {
  const canvas = document.createElement('canvas');
  if (!!(canvas.getContext && canvas.getContext('2d'))) {
    return canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }
  return false;
};
